<div appSubtitle1>{{ name() }}</div>
<app-location-evse-contract-pricing
  [contract]="contract()"
  [messages]="messages()"
></app-location-evse-contract-pricing>

@if (selected() && !disabled()) {
  <etn-icon [name]="selectedIcon.name" [color]="selectedIcon.color"></etn-icon>
}
